import { Component, OnDestroy, AfterViewInit, OnInit, Input, OnChanges, Output, EventEmitter, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { CrudUserFacade, CrudUserMode, CrudUserRoleContext } from './crud-user.facade';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChipModule } from 'primeng/chip';
import { MessagesModule } from 'primeng/messages'; // Import MessagesModule
import { UserOrgPermission } from '../../global-data-models/user.model'; // Import UserOrgPermission
import { TranslateModule } from '@ngx-translate/core';
import { GlobalConsentFormComponent } from "../../global-components/global-consent-form/global-consent-form.component";

@Component({
    selector: 'app-crud-user',
    imports: [...COMMON_IMPORTS, DropdownModule, MultiSelectModule, ChipModule, MessagesModule, TranslateModule, GlobalConsentFormComponent],
    templateUrl: './crud-user.component.html',
    styleUrls: ['./crud-user.component.css']
})
export class CrudUserComponent implements AfterViewInit, OnInit, OnDestroy, OnChanges {
  @Input() mode: CrudUserMode = 'read';
  @Input() roleContext: CrudUserRoleContext = 'me';
  @Input() userId?: string;
  @Input() orgId?: string;
  @Output() cancelPressed = new EventEmitter<void>();
  @Output() updateSuccess = new EventEmitter<void>();
  @Output() createSuccess = new EventEmitter<void>();

  @ViewChild(GlobalConsentFormComponent) consentForm!: GlobalConsentFormComponent;


  form: FormGroup = this.facade.form;
  currentMode: CrudUserMode = 'read';
  private sub = new Subscription();

  constructor(private facade: CrudUserFacade) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.facade.begin(this.consentForm, this.mode, this.roleContext, this.userId, this.orgId);

    this.sub.add(
      this.facade.state$.subscribe((state) => {
        this.form = state.form;
        this.currentMode = state.mode;
      }),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['mode'] && !changes['mode'].firstChange) ||
      (changes['roleContext'] && !changes['roleContext'].firstChange) ||
      (changes['userId'] && !changes['userId'].firstChange) ||
      (changes['orgId'] && !changes['orgId'].firstChange)
    ) {
      this.facade.begin(this.consentForm, this.mode, this.roleContext, this.userId, this.orgId);
    }
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  async onSave() {
    const success = await this.facade.saveButtonPressed(this.mode, this.roleContext, this.userId, this.orgId);
    if (success && this.mode === 'update') {
      this.updateSuccess.emit();
      return;
    }

    if (success && this.mode === 'create') {
      this.createSuccess.emit();
      return;
    }
  }

  onCancel() {
    this.cancelPressed.emit();
  }

  async onDeletePermission(permission: UserOrgPermission) {
    const success = await this.facade.deletePermission(permission);
    if (success && this.mode === 'update') {
      this.updateSuccess.emit();
      return;
    }
  }
}
